import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/functions'

export default () => {
  firebase.initializeApp(firebaseConfig)

  if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
    firebase
      .auth()
      .useEmulator('http://localhost:9099', { disableWarnings: true })
    firebase.database().useEmulator('localhost', 9000)
    firebase.storage().useEmulator('localhost', 9199)
    firebase.functions().useEmulator('localhost', 5001)
  }

  return firebase
}
